import {
  format,
  parseISO,
  isDate,
  differenceInCalendarDays,
  addDays,
  differenceInDays,
  differenceInMinutes
} from 'date-fns';

export const formatDate = (date, dateFormat) => {
  return format(getDate(date), dateFormat);
};

export const getDate = date => {
  return isDate(date) ? date : parseISO(date);
};

export const getDifferenceInMinutes = (dateFrom, dateTo) => {
  return differenceInMinutes(getDate(dateFrom), getDate(dateTo));
};

export const getDifferenceInDays = (dateFrom, dateTo) => {
  return differenceInDays(getDate(dateFrom), getDate(dateTo));
};

export const getDifferenceInCalendarDays = (dateFrom, dateTo) => {
  return differenceInCalendarDays(getDate(dateFrom), getDate(dateTo));
};

export const addAdditionalDays = (date, amountOfDays) => {
  return addDays(getDate(date), amountOfDays);
};
